export const ConnectionType = {
  SINGLE_PHASE: 0,
  THREE_PHASE: 1,
};

export const ConnectionTypeText = {
  [ConnectionType.SINGLE_PHASE]: 'Single Phase',
  [ConnectionType.THREE_PHASE]: 'Three Phase',
};
